import { Panel } from 'primereact/panel';
import React from 'react'


const Resumen = (props) => {
    
    const bodyCurrencySmall = (data) => {

        if (data) {
            let n = parseFloat(data);

            return (<div className="d-flex justify-content-between">
                <small >{'$ '}</small>

                <small >{n.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</small>
            </div>
            )

        }
    }
    const bodyCant = (data) => {

        if (data) {
            let n = parseFloat(data);

            return <small className="d-flex justify-content-end">{n.toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</small>

        }
    }
    return (
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-4">
            <Panel header={'Resumen'}>

                <div className="p-grid p-justify-between">
                    <div className="p-col-5">
                        <div className="p-grid p-justify-between border border-black-50 rounded-lg rounded-top  mt-3">
                            <div className="p-col-8 border border-black-50 bg-light  ">
                                <span className="font-weight-bold " >Item</span>
                            </div>
                            <div className="p-col-4 border border-black-50 bg-light text-center">
                                <span className="font-weight-bold" >Importe</span>
                            </div>
                            {/*Vtas*/}
                            <div className="p-col-8 border border-black-50 ">
                                <span className="font-weight-normal" ><small >Ventas en Comercio Sin Desc ($ Surtidor):</small ></span>
                            </div>

                            <div className="p-col-4 border border-black-50 ">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.vtasComercioSinDesc)}</span>
                            </div>
                            <div className="p-col-8 border border-black-50 ">
                                <span className="font-weight-normal" ><small >Ventas en Comercio con Desc.:</small ></span>
                            </div>

                            <div className="p-col-4 border border-black-50 ">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.vtasComercio)}</span>
                            </div>

                            <div className="p-col-8 border border-black-50 ">
                                <span className="font-weight-normal" ><small >Devolución descuentos Neto:</small ></span>
                            </div>
                            <div className="p-col-4 border border-black-50 ">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.devolucionDescuentos)}</span>
                            </div>
                            <div className="p-col-8 border border-black-50 ">
                                <span className="font-weight-normal" ><small >Comision Programa Neto:</small ></span>
                            </div>

                            <div className="p-col-4 border border-black-50 ">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.comisionPrograma)}</span>
                            </div>
                            <div className="p-col-8 border border-black-50 ">
                                <span className="font-weight-normal" ><small >Ajuste Cta. Corriente:</small ></span>
                            </div>
                            <div className="p-col-4 border border-black-50 ">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.ajusteCtaCorriente)}</span>
                            </div>
                            <div className="p-col-8 border border-black-50 ">
                                <span className="font-weight-normal" ><small >Acreditación por ventas Neto:</small ></span>
                            </div>
                            <div className="p-col-4 border border-black-50 ">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.acreditacionVta)}</span>
                            </div>
                            <div className="p-col-8 border border-black-50 " title="Impuestos Acreditación por ventas + Impuestos Devolución descuentos - Impuestos Comisión Programa" >
                                <span className="font-weight-normal" ><small >Impuestos:</small ></span>
                            </div>
                            <div className="p-col-4 border border-black-50 " title="Impuestos Acreditación por ventas + Impuestos Devolución descuentos - Impuestos Comisión Programa">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.impuestos)}</span>
                            </div>
                        </div>
                    </div>
                    <div className="p-col-5">
                        <div className="p-grid p-justify-between border  border-black-50  mt-3">
                            <div className="p-col-12 border  border-black-50 bg-light ">
                                <span className="font-weight-bold" >Margen Calculado</span>
                            </div>
                            <div className="p-col-8 border  border-black-50 " title="Ventas en comercio Bruto + Devolución Descuentos Bruto - Comisión Programa Bruto">
                                <span className="font-weight-normal" ><small >Total Bruto:</small ></span>
                            </div>
                            <div className="p-col-4 border  border-black-50 " title="Ventas en comercio Bruto + Devolución Descuentos Bruto - Comisión Programa Bruto">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.bruto)}</span>
                            </div>
                            <div className="p-col-8 border  border-black-50 " title="Ventas en comercio Neto + Devolución Descuentos Neto - Comisión Programa Neto" >
                                <span className="font-weight-normal" ><small >Total Neto:</small ></span>
                            </div>
                            <div className="p-col-4 border  border-black-50 " title="Ventas en comercio Neto + Devolución Descuentos Neto - Comisión Programa Neto">
                                <span className="font-weight-normal" >{bodyCurrencySmall(props.state.neto)}</span>
                            </div>
                            <div className="p-col-8 border  border-black-50 " title="Sumatoria de litros consumidos en las Ventas en Comercio">
                                <span className="font-weight-normal" ><small >Total Lts.:</small ></span>
                            </div>
                            <div className="p-col-4 border  border-black-50 " title="Sumatoria de litros consumidos en las Ventas en Comercio" >
                                <span className="font-weight-normal">{bodyCant(props.state.lts)}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </Panel>
        </div>

    );
}

export default Resumen